import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { NewEvent } from '@ilteducation/activity-stream-types';

const eventCacheStore = defineStore('event-cache-store', () => {
  const cache = ref<NewEvent[]>([]);
  const addAll = (events: NewEvent[]) => {
    cache.value.push(...events);

    cache.value.sort((a, b) => {
      const timeA = a.timestamp ? a.timestamp.getTime() : Infinity;
      const timeB = b.timestamp ? b.timestamp.getTime() : Infinity;

      return timeA - timeB;
    });
  };

  const clear = () => {
    cache.value = [];
  };

  return {
    addAll,
    cache,
    clear,
  };
});

export default eventCacheStore;
